<!-- QuickView always shows - only data overlays are conditional -->
<div class="plink-quick-view-container">
  <div class="panel panel-default">
    <div class="panel-header">
      PolarLink QuickView
      <span *ngIf="deviceId > 0"> - Device ID: {{deviceId}}</span>
      <span *ngIf="deviceId === 0"> - No Device Selected</span>
    </div>
    <div class="panel-body">

      <!-- begin graphic block -->
      <!-- Main QuickView Display -->
      <div class="quick-view-display">
        <!-- SVG QuickView Container -->
        <div class="svg-quickview-container">
          <!-- SVG with embedded background and overlays -->
          <svg viewBox="0 0 800 600" class="quickview-svg" *ngIf="!imageLoadError">
            <!-- Background image embedded in SVG -->
            <image href="/assets/images/RSE/QV/RSE-QV-PL-Standard-Trimmed.png"
                   width="800"
                   height="600"
                   (error)="onImageError($event)"
                   (load)="onImageLoad($event)"/>

            <!-- Status LEDs - positioned exactly where they should be -->
            <!-- AC In LED -->
            <circle [attr.cx]="ledPositions.acIn.x"
                    [attr.cy]="ledPositions.acIn.y"
                    r="12"
                    [attr.fill]="getStatusColor(plinkAcIn)"
                    [attr.stroke]="getStatusStroke(plinkAcIn)"
                    stroke-width="2"
                    class="status-led"/>

            <!-- Connected LED -->
            <circle [attr.cx]="ledPositions.connected.x"
                    [attr.cy]="ledPositions.connected.y"
                    r="12"
                    [attr.fill]="getStatusColor(plinkConnected)"
                    [attr.stroke]="getStatusStroke(plinkConnected)"
                    stroke-width="2"
                    class="status-led"/>

            <!-- AC Out LED -->
            <circle [attr.cx]="ledPositions.acOut.x"
                    [attr.cy]="ledPositions.acOut.y"
                    r="12"
                    [attr.fill]="getStatusColor(plinkAcOut)"
                    [attr.stroke]="getStatusStroke(plinkAcOut)"
                    stroke-width="2"
                    class="status-led"/>

            <!-- Fault LED -->
            <circle [attr.cx]="ledPositions.fault.x"
                    [attr.cy]="ledPositions.fault.y"
                    r="12"
                    [attr.fill]="getStatusColor(plinkFault)"
                    [attr.stroke]="getStatusStroke(plinkFault)"
                    stroke-width="2"
                    class="status-led"/>

            <!-- Text overlays - labels now part of background image -->
            <!-- Duration Display -->
            <text [attr.x]="textPositions.duration.valueX"
                  [attr.y]="textPositions.duration.valueY"
                  class="svg-value-text-regular">{{duration}}</text>

            <!-- kWh Display -->
            <text [attr.x]="textPositions.kwh.valueX"
                  [attr.y]="textPositions.kwh.valueY"
                  class="svg-value-text-regular">{{kwhrs | number:'1.2-2'}}</text>
          </svg>

          <!-- Fallback if image doesn't load -->
          <div *ngIf="imageLoadError" class="image-fallback">
            <div style="text-align: center;">
              <h3>QuickView Image Not Found</h3>
              <p>Expected: /assets/images/RSE/QV/RSE-QV-PL-Standard-Trimmed.png</p>
              <p>Status boxes and timer should still work below:</p>
            </div>
          </div>
        </div>
      </div>
      <!-- end graphic block -->

    </div>
  </div>
</div>

<!-- Optional: Add instruction text when no device selected -->
<div *ngIf="deviceId === 0" class="panel panel-info" style="margin-top: 20px;">
  <div class="panel-body text-center">
    <i class="fa fa-info-circle"></i>
    <strong>Select a PolarLink device above to view real-time status and data.</strong>
  </div>
</div>
